import { render, staticRenderFns } from "./send-rule-view.vue?vue&type=template&id=b6abedcc&scoped=true&"
import script from "./send-rule-view.vue?vue&type=script&lang=js&"
export * from "./send-rule-view.vue?vue&type=script&lang=js&"
import style0 from "./send-rule-view.vue?vue&type=style&index=0&id=b6abedcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6abedcc",
  null
  
)

export default component.exports